// 出現演出

import { isLoading } from "./loading";

const PREFERS_REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// 出現の単位 親が対象なら子孫は除外
const TARGETS = [
	".hero .lead > *",
	".sec > .inner > .title",
	".sec > .inner > .lead[data-reveal]",
	".sec > .inner > .chart",
	".sec > .inner > .btn-wrapper",
	".sec > .inner > .btn",
	".anchor > *",
	".cards > *",
	".schedule-list > *",
	".sponsor .list > *",
];

let observer = null;
const initialized = new WeakSet();

const getObserver = () => {
	if (observer) return observer;

	observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				// ローディング中は開いてから動かす
				if (isLoading()) {
					window.addEventListener("site:loaded", () => entry.target.classList.add("is-in"), { once: true });
					return;
				}
				entry.target.classList.add("is-in");
			});
		},
		{
			root: null,
			// 少し入ってから動かす
			rootMargin: "0px 0px -10% 0px",
			threshold: 0,
		},
	);

	return observer;
};

/**
 * 対象を集めて入れ子を間引く
 * @param {Element|Document} scope
 * @returns {Element[]}
 */
const collect = (scope) => {
	const found = [...scope.querySelectorAll(TARGETS.join(","))];
	return found.filter((el) => !found.some((other) => other !== el && other.contains(el)));
};

/**
 * @param {Element|Document} scope - 探索範囲
 */
export const initReveal = (scope = document) => {
	if (PREFERS_REDUCED_MOTION) return;

	document.documentElement.classList.add("has-reveal");

	const io = getObserver();
	const counters = new Map();
	const added = [];

	collect(scope).forEach((node) => {
		if (initialized.has(node)) return;
		initialized.add(node);

		const el = node;

		// 並び順を遅延に使う
		const parent = el.parentElement;
		const index = counters.get(parent) || 0;
		counters.set(parent, index + 1);
		el.style.setProperty("--i", index);

		if (el.hasAttribute("data-reveal")) {
			io.observe(el);
			return;
		}

		// 付与直後は遷移させない
		el.style.transition = "none";
		el.setAttribute("data-reveal", "");
		added.push(el);
	});

	if (added.length === 0) return;

	// レイアウトを確定させる
	document.documentElement.getBoundingClientRect();

	added.forEach((el) => {
		el.style.removeProperty("transition");
		io.observe(el);
	});
};

export default initReveal;
